
class EventType {
    static TYPE_SOCKET_STATE:string = 'msg_type_socket_state';
    static TYPE_ROOM_MESSAGE:string = 'msg_type_room_message';
}

export default EventType